import { defineStore } from 'pinia'
import { likesCountResource } from '@services/likes.service'

export const useLikesStore = defineStore('likes', {
  state: () => ({
    likes: {
      count: 0,
      isDeterminated: false,
    },
    lastAction: {
      removed: null,
      added: null,
    },
  }),

  getters: {
    likesInfo: state => state.likes,
    lastActionInfo: state => state.lastAction,
  },

  actions: {
    async getLikesData() {
      const data = await likesCountResource.execute()

      this.setLikesInfo(data.item)
    },

    setLikesInfo(data: any) {
      this.likes = { ...data, isDeterminated: true }
    },

    setRemovedId(val: number | null) {
      this.lastAction.removed = val
    },

    setAddedId(val: number | null) {
      this.lastAction.added = val
    },
  },
})
